import { getToday } from '@/common/functions/getToday';
import { useRef } from 'react';

const useSpendsSearchBox = () => {
	const today = getToday();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	return {
		today,
		dateFromRef,
		dateToRef,
	};
};

export default useSpendsSearchBox;
